<script>
  import { fade, fly } from 'svelte/transition'
  import store from '~/Library/store'
</script>

<div class="overlay" on:click={() => store.setAttribute('show_video', false)} transition:fade="{{ duration: 500 }}">

  <div class="modal" transition:fly="{{ y: 100, duration: 250 }}">

    <img src="/static/icons/close-modal.svg" alt="" class="modal__close">

    <iframe title="Video" src={$store.video_source} width="640" height="480" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>

  </div>

</div>


<style lang="scss">

  div.modal {

    display: flex;
    align-items: center;

    width: 40rem;
    height: 30rem;
    background-color: white;
    padding: 1rem;

    iframe {
      max-width: 100%; 
    }

  }

  .modal__close {
    padding: 2rem;
  }

</style>
